<template>
  <v-container
    fluid
    tag="section"
    class="privat-setting-modal"
  >
    <v-row justify="start">
      <v-dialog
        v-model="isShowModal"
        persistent
        max-width="440"
      >
        <v-card>
          <v-card-title class="headline">
            Добавить Настройки
            <v-btn
              color="green darken-1"
              text
              class="close-btn"
              @click="closeModal()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <form>
              <!-- Id -->
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-text-field
                  v-model="formData.login"
                  v-validate="'required'"
                  :error-messages="errors.collect('login')"
                  label="login"
                  data-vv-name="login"
                  validate-on-blur
                  required
                  color="purple darken-2"
                  clearable
                  prepend-icon="mdi-account-edit"
                />
              </v-col>

              <!-- password -->
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-text-field
                  v-model="formData.password"
                  v-validate="'required'"
                  :error-messages="errors.collect('password')"
                  label="password"
                  data-vv-name="password"
                  validate-on-blur
                  required
                  color="purple darken-2"
                  clearable
                  prepend-icon="mdi-account-edit"
                />
              </v-col>

              <v-col
                cols="12"
                class="pb-0"
              >
                <div @click="pickFile">
                  <v-text-field
                    v-validate="'required'"
                    disabled
                    label="Загрузить файл"
                    :value="avalFile"
                    prepend-icon="attach_file"
                    name="avalFile"
                    :error-messages="errors.collect('avalFile')"
                  />
                  <input
                    ref="avalFile"
                    type="file"
                    style="display: none"
                    accept=".dat"
                    @change="onFilePicked"
                  >
                </div>
              </v-col>

              <v-col
                cols="12"
                class="py-0 my-4 text-center"
              >
                <v-btn
                  class="mr-0"
                  color="#0051ff"
                  :disabled="errors.any() || isSendFormCompanyBankAccountSettings"
                  @click="save"
                >
                  Сохранить
                </v-btn>
              </v-col>
            </form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AddAvalBankSettingModal',
    props: {
      isShowModal: {
        type: Boolean,
        default: false,
      },
      form: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        formData: {},
        avalFile: '',
      }
    },

    computed: {
      ...mapGetters('companyBankAccountSettings', ['isSendFormCompanyBankAccountSettings']),
    },

    created () {
      this.formData = Object.assign({}, this.form)
      this.formData.bank_alias = 'aval'
    },

    methods: {
      closeModal () {
        this.$emit('closeModal')
      },

      save () {
        this.$validator.validateAll().then(validated => {
          if (!validated) {
            return
          }

          this.$emit('save', Object.assign({}, this.formData))
        })
      },

      pickFile () {
        this.$refs.avalFile.click()
      },

      onFilePicked () {
        const file = this.$refs.avalFile.files[0]
        this.avalFile = file ? file.name : ''
        this.formData.key_file_name = file
      },
    },
  }
</script>

<style scoped>

</style>
